/**
 * 接口角色选择
 * @author lhu
 * @date 2020-1-2
 */
import React from 'react';
import { connect } from 'dva';
import { framework_tool, component_tool, utils_tool  } from '../../../../tool';
import { modelUtils } from "../../../../utils";
let { WizContainer } = framework_tool;
let { WizTag, WizTableTransfer } = component_tool;
let { $$ } = utils_tool;
/**
 * 左边表格columns
 */
const leftTableColumns = [
  {
    dataIndex: 'title',
    title: '名称',
  },
  {
    dataIndex: 'code',
    title: '编码'
  },
  {
    dataIndex: 'remark',
    title: '备注',
  },
];

/**
 * 右边表格columns
 */
const rightTableColumns = [
  {
    dataIndex: 'title',
    title: '名称',
  },
  {
    dataIndex: 'code',
    title: '编码',
  }
];

class ApiRoleSelect extends WizContainer {

  componentName = 'ApiRoleSelect';

  constructor(props) {
    super(props);
    this.state = {
      targetKeys: [],
    }
  }


  /**
   * 接口新增角色
   */
  _doApiRoleAdd = () => {
    if (this.props.record.id){
      this.doAction({
        path: "apiInfo/addRoleApiMany",
        payload: {
          key: "addRoleApiManyKey",
          apiParams: {
            "apiInfoId":this.props.record.id,
            "roleIds":this.state.targetKeys
          }
        }
      });
    }else {
      wizNotice.warn("请先选择接口");
    }
  };

  onChange = nextTargetKeys => {
    this.setState({ targetKeys: nextTargetKeys });
  };

  _componentDidMount = () => {
      this._getData();
      this._getApiRoleData();
  };

  propsAndStateOnChange = {
    apiRoleList: this._setTargetKeys.bind(this),
    apiRoleResult:this._setRoleAddState.bind(this)
  }

  _setTargetKeys(nextProps, nextState) {
    let targetIds =[];
    nextProps.apiRoleList.data.forEach(data =>{
      targetIds.push(data.roleId)
    });
    nextState.targetKeys = targetIds;
    return true;
  }

  _setRoleAddState(nextProps, nextState){
    if(nextProps.apiRoleResult.code === 1){
      wizNotice.success("操作成功");
      this.props.changeModal(false);
    }else{
      wizNotice.error(nextProps.apiRoleResult.msg);
    }

  }
  _getData() {
    this.doAction({
      path: "role/getListByCondition",
      payload: {
        key: "roleGetListByConditionKey",
        apiParams: {  }
      }
    });
  }

  /**
   * 根据接口id获取角色列表
   */
  _getApiRoleData() {
    this.doAction({
      path: "apiInfo/getRoleApiListByQry",
      payload: {
        key: "apiRoleListKey@"+this.props.record.id,
        apiParams: {
          "apiInfoId":this.props.record.id,
        }
      }
    });
  }





  _render() {
    const { targetKeys } = this.state;
    let listData = this.props.roleList.data?this.props.roleList.data:[];
    const mockData = [];
    let returnView = null;
    listData.forEach(roleData =>{
      mockData.push({
        key: roleData.id,
        title: roleData.name,
        code:roleData.code,
        remark:roleData.remark,
        disabled: false,
      })
    }
    );

      returnView  = <WizTableTransfer
      key={this.props.record.id}
      dataSource={mockData}
      targetKeys={targetKeys}
      onChange={this.onChange}
      filterOption={(inputValue, item) =>
        item.title.indexOf(inputValue) !== -1 || item.code.indexOf(inputValue) !== -1 || item.remark.indexOf(inputValue) !== -1
      }
      leftColumns={leftTableColumns}
      rightColumns={rightTableColumns}
    />

    return returnView;
  }
}

const mapStateToProps = (state, ownProps) => {
  const { role,apiInfo } = state;
  const roleList = modelUtils.getModelEntity(role, "roleGetListByConditionKey");
  const apiRoleList = modelUtils.getModelEntity(apiInfo, "apiRoleListKey@"+ownProps.record.id);
  const apiRoleResult = modelUtils.getModelEntity(apiInfo, "addRoleApiManyKey");
  return {
    roleList: roleList,
    apiRoleList:apiRoleList,
    apiRoleResult:apiRoleResult
  }
};

const options = { withRef: true };

export default connect(mapStateToProps, null, null, options)(ApiRoleSelect);

